/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Plan_Feature_Team_StorageInputs */



/**
* | output |
* | --- |
* | "{size} storage / user" |
*
* @param {Plan_Feature_Team_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_team_storage = /** @type {((inputs: Plan_Feature_Team_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Team_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.size} Speicher / Nutzer`)
	return /** @type {LocalizedString} */ (`${i?.size} storage / user`)
});